var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewedDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C1.79455 0 0 1.79455 0 6C0 10.2055 1.79455 12 6 12C10.2055 12 12 10.2055 12 6C12 1.79455 10.2055 0 6 0ZM8.89364 4.65764C8.178 5.77745 7.15909 7.18091 5.62036 8.10436C5.44364 8.21073 5.22164 8.208 5.04764 8.09727C4.21855 7.572 3.59618 7.00909 3.08727 6.32564C2.90727 6.084 2.95745 5.74255 3.19909 5.56255C3.44018 5.38255 3.78218 5.43327 3.96164 5.67436C4.32927 6.168 4.77327 6.59018 5.34491 6.98618C6.52309 6.18982 7.33255 5.07327 7.97345 4.07018C8.13655 3.816 8.47364 3.74182 8.72673 3.90436C8.98091 4.06691 9.05564 4.404 8.89364 4.65764Z",
    fill: "#1BA200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewedDocuments);
export default __webpack_public_path__ + "static/media/viewed_documents.4306cc1fc49accc6669d7c9171e7ddbc.svg";
export { ForwardRef as ReactComponent };